<script>
	export let place;
</script>

<main>
	<h1>Welcome to {place}</h1>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
	}

	h1 {
		text-transform: uppercase;
		font-size: 4em;
	}
</style>
